import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import configBase from '../../../configBase';
import axios from 'axios';
import '../../../assets/scss/dashboard.scss';
import { ResponsiveLine } from '@nivo/line'

import { Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import RateReviewIcon from '@material-ui/icons/RateReview';
import UpdateIcon from '@material-ui/icons/Update';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';
import PeopleIcon from '@material-ui/icons/People';
import WorkIcon from '@material-ui/icons/Work';
import Switch from '@material-ui/core/Switch';
import LoopIcon from '@material-ui/icons/Loop';
import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay';

import {
  Main as MainLayout,
} from '../../../layouts';


class Dashboard extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      countAwaitingSolution: 'X',
      countWaitingConfirmation: 'X',
      countClientConfirmation: 'X',
      countImplantedContracts: 'X',
      countCanceledContracts: 'X',
      countInAverbation: 'X',
      countMaterials: 'X',
      countPending: 'X',
      countDependents: 'X',
      countFuncEmpresa: 'X',

      showAwaitingSolution: false,
      showInAverbation: false,
      showWaitingConfirmation: false,
      showClientConfirmation: false,
      showImplantedContracts: false,
      showCanceledContracts: false,
      showPending: false,
      showDependents: false,
      showFuncEmpresa: false,

      countPJawaitingPayment: 'X',
      countPJawaitingConfirmation: 'X',
      countPJprocessing: 'X',
      countPJinValidation: 'X',
      countPJafterSales: 'X',
      countPJpending: 'X',
      countPJdeployed60Days: 'X',
      countPJcanceled60Days: 'X',

      showPJawaitingPayment: false,
      showPJawaitingConfirmation: false,
      showPJprocessing: false,
      showPJonActivation: false,
      showPJactivated: false,
      showPJinValidation: false,
      showPJafterSales: false,
      showPJpending: false,
      showPJdeployed60Days: false,
      showPJcanceled60Days: false,

      errorRequest: false,
      msgErrorRequest: '',

      dashboardColors: {
        novas: {
          color: configBase.corSecundaria,
          colorNumber: configBase.corSecundaria,
          bg: configBase.corPrincipal,
          colorIcon: configBase.corPrincipal,
          bgIcon: configBase.corSecundaria,
          defaultColor: configBase.corNova,
          defaultBg: configBase.bgNova,
          defaultStatus: configBase.statusNova,
        },
        indeferidas: {
          color: '#546e7a', bg: configBase.corIndeferida, colorNumber: '#263238',
          colorIcon: configBase.corIndeferida, bgIcon: configBase.bgIndeferida,
          defaultColor: configBase.corIndeferida, defaultBg: configBase.bgIndeferida,
          defaultStatus: configBase.statusIndeferida,
        },
        pendentes: {
          color: '#546e7a', bg: configBase.corPendente, colorNumber: '#263238',
          colorIcon: configBase.corPendente, bgIcon: configBase.bgPendente,
          defaultColor: configBase.corPendente, defaultBg: configBase.bgPendente,
          defaultStatus: configBase.statusPendente,
        },
        emaverbacao: {
          color: '#546e7a', bg: configBase.corEmAverbacao, colorNumber: '#263238',
          colorIcon: configBase.corEmAverbacao, bgIcon: configBase.bgEmAverbacao,
          defaultColor: configBase.corEmAverbacao, defaultBg: configBase.bgEmAverbacao,
          defaultStatus: configBase.statusEmAverbacao,
        },
        emanalise: {
          color: '#546e7a', bg: configBase.corEmAnalise, colorNumber: '#263238',
          colorIcon: configBase.corEmAnalise, bgIcon: configBase.bgEmAnalise,
          defaultColor: configBase.corEmAnalise, defaultBg: configBase.bgEmAnalise,
          defaultStatus: configBase.statusEmAnalise,
        },
        canceladas: {
          color: '#546e7a', bg: configBase.corCanceladas, colorNumber: '#263238',
          colorIcon: configBase.corCanceladas, bgIcon: configBase.bgCanceladas,
          defaultColor: configBase.corCanceladas, defaultBg: configBase.bgCanceladas,
          defaultStatus: configBase.statusCanceladas,
        },
        implantadas: {
          color: '#546e7a', bg: configBase.corImplementadas, colorNumber: '#263238',
          colorIcon: configBase.corImplementadas, bgIcon: configBase.bgImplementadas,
          defaultColor: configBase.corImplementadas, defaultBg: configBase.bgImplementadas,
          defaultStatus: configBase.statusImplementadas,
        },
        dependentes: {
          color: '#546e7a', bg: configBase.corDependentes, colorNumber: '#263238',
          colorIcon: configBase.corDependentes, bgIcon: configBase.bgDependentes,
          defaultColor: configBase.corDependentes, defaultBg: configBase.bgDependentes,
          defaultStatus: configBase.statusDependentes,
        },
        funcempresa: {
          color: '#546e7a', bg: configBase.corFuncEmpresa, colorNumber: '#263238',
          colorIcon: configBase.corFuncEmpresa, bgIcon: configBase.bgFuncEmpresa,
          defaultColor: configBase.corFuncEmpresa, defaultBg: configBase.bgFuncEmpresa,
          defaultStatus: configBase.statusFuncEmpresa,
        },

        indeferidasPJ: {
          color: '#546e7a', bg: configBase.corIndeferidaPJ, colorNumber: '#263238',
          colorIcon: configBase.corIndeferidaPJ, bgIcon: configBase.bgIndeferidaPJ,
          defaultColor: configBase.corIndeferidaPJ, defaultBg: configBase.bgIndeferidaPJ,
          defaultStatus: configBase.statusIndeferidaPJ,
        },
        pendentesPJ: {
          color: '#546e7a', bg: configBase.corPendentePJ, colorNumber: '#263238',
          colorIcon: configBase.corPendentePJ, bgIcon: configBase.bgPendentePJ,
          defaultColor: configBase.corPendentePJ, defaultBg: configBase.bgPendentePJ,
          defaultStatus: configBase.statusPendentePJ,
        },
        confPendentesPJ: {
          color: '#546e7a', bg: configBase.corConfPendentePJ, colorNumber: '#263238',
          colorIcon: configBase.corConfPendentePJ, bgIcon: configBase.bgConfPendentePJ,
          defaultColor: configBase.corConfbgConfPendentePJ, defaultBg: configBase.bgConfPendentePJ,
          defaultStatus: configBase.statusConfbgConfPendentePJ,
        },
        emprocessamentoPJ: {
          color: '#546e7a', bg: configBase.corEmProcessamentoPJ, colorNumber: '#263238',
          colorIcon: configBase.corEmProcessamentoPJ, bgIcon: configBase.bgEmProcessamentoPJ,
          defaultColor: configBase.corEmProcessamentoPJ, defaultBg: configBase.bgEmProcessamentoPJ,
          defaultStatus: configBase.statusEmProcessamentoPJ,
        },
        emanalisePJ: {
          color: '#546e7a', bg: configBase.corEmAnalisePJ, colorNumber: '#263238',
          colorIcon: configBase.corEmAnalisePJ, bgIcon: configBase.bgEmAnalisePJ,
          defaultColor: configBase.corEmAnalisePJ, defaultBg: configBase.bgEmAnalisePJ,
          defaultStatus: configBase.statusEmAnalisePJ,
        },
        canceladasPJ: {
          color: '#546e7a', bg: configBase.corCanceladasPJ, colorNumber: '#263238',
          colorIcon: configBase.corCanceladasPJ, bgIcon: configBase.bgCanceladasPJ,
          defaultColor: configBase.corCanceladasPJ, defaultBg: configBase.bgCanceladasPJ,
          defaultStatus: configBase.statusCanceladasPJ,
        },
        implantadasPJ: {
          color: '#546e7a', bg: configBase.corImplementadasPJ, colorNumber: '#263238',
          colorIcon: configBase.corImplementadasPJ, bgIcon: configBase.bgImplementadasPJ,
          defaultColor: configBase.corImplementadasPJ, defaultBg: configBase.bgImplementadasPJ,
          defaultStatus: configBase.statusImplementadasPJ,
        },
      },
      showCharts: false,
      chartsName: configBase.statusNova,
      chartsColor: configBase.bgNova,
      daysCharts: '7',
      typeCharts: '',

      data: [],

      checkedTypeDashboard: false,
    };

    this.styles = {
      icon: {
        flex: '0 0 auto', padding: 12, overflow: 'visible', fontSize: '1.5rem',
        textAlign: 'center', transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        borderRadius: '50%',border: 0, margin: 0, display: 'inline-flex',  outline: 0,
        position: 'relative', alignTtems: 'center', userSelect: 'none', verticalAlign: 'middle',
        justifyContent: 'center', textDecoration: 'none',
      },
      buttonPaper: {
        width: '100%',
        minHeight: 88,
        padding: 0,
        boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
        backgroundColor: '#fff',
      }
    };

  }


  componentDidMount() {
    let url = configBase.api + 'Sales/dataDashboard?access_token='+localStorage.getItem('planos_t');
    let dataSubmit = {
      userId: localStorage.getItem('planos_u')
    };

    axios.post(url, dataSubmit)
    .then((response) => {
      let state = this.state;
      state.countLeads = response.data.leads;
      state.countAwaitingSolution = response.data.awaitingSolution;
      state.countWaitingConfirmation = response.data.waitingConfirmation;
      state.countClientConfirmation = response.data.clientConfirmation;
      state.countImplantedContracts = response.data.implantedContracts;
      state.countCanceledContracts = response.data.canceledContracts;
      state.countInAverbation = response.data.inAverbation;
      state.countMaterials = response.data.materials;
      state.countPending = response.data.pending;
      state.countDependents = response.data.dependents;
      state.countFuncEmpresa = response.data.funcEmpresas;
      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar quantidade de propostas');
    }.bind(this));

    // Busca quantidade para caixinhas do PJ
    this.getCountPj();

    // Verifica o perfil para exibição de caixas de resumo
    this.showBox();
  }

  showBox() {
    let state = this.state;
    let type = localStorage.getItem('planos_y');

    if (type === 'SALESMAN' || type === 'BROKER'|| type === 'BACKOFFICE') {
      state.showInAverbation = true;
      state.showAwaitingSolution = true;
      state.showWaitingConfirmation = true;
      state.showClientConfirmation = true;
      state.showImplantedContracts = true;
      state.showCanceledContracts = true;
      state.showPending = true;
      state.showPJpending = true;
      state.showPJawaitingPayment = true;
      state.showPJawaitingConfirmation = true;
      state.showPJprocessing = true;
      state.showPJinValidation = true;
      state.showPJcanceled60Days = true;
      state.showPJdeployed60Days = true;

      if (configBase.moduloDependentes === true) {
        if (type === 'SALESMAN')
          state.showDependents = true;
      }

      if (configBase.moduloFuncEmpresa === true)
        state.showFuncEmpresa = true;
    }
    else if (type === 'REGISTER') {
      state.showInAverbation = true;
      state.showImplantedContracts = true;
      state.showWaitingConfirmation = true;
      state.showCanceledContracts = true;
      state.showPending = true;
      state.showPJpending = true;
      state.showPJinValidation = true;
      state.showPJcanceled60Days = true;
      state.showPJdeployed60Days = true;
      state.showPJprocessing = true;
      
      if (configBase.moduloDependentes === true)
        state.showDependents = true;

      if (configBase.moduloFuncEmpresa === true)
        state.showFuncEmpresa = true;
    }
    else if (type === 'AFTER SALES') {
      state.showInAverbation = true;
      state.showImplantedContracts = true;
      state.showWaitingConfirmation = true;
      state.showCanceledContracts = true;
      state.showPending = true;
      state.showPJpending = true;
      state.showPJinValidation = true;
      state.showPJcanceled60Days = true;
      state.showPJdeployed60Days = true;

      if (configBase.moduloFuncEmpresa === true)
        state.showFuncEmpresa = true;
    }
    else if (type === 'ADMIN') {
      state.showInAverbation = true;
      state.showWaitingConfirmation = true;
      state.showImplantedContracts = true;
      state.showCanceledContracts = true;
      state.showPending = true;
      state.showPJpending = true;
      state.showPJinValidation = true;
      state.showPJcanceled60Days = true;
      state.showPJdeployed60Days = true;

      if (configBase.moduloFuncEmpresa === true)
        state.showFuncEmpresa = true;
    }

    this.setState(state);
  }

  goList(url) {
    this.props.history.push(`${process.env.PUBLIC_URL}/${url}`);
  }

  goShowCharts(type=null) {
    let listType = {
      novas: 'clientConfirmation',
      pendentes: 'awaitingSolution',
      emanalise: 'waitingConfirmation',
      implantadas: 'implantedContracts',
      canceladas: 'canceledContracts',
      indeferidas: 'pending',
      emaverbacao: 'inAverbation',
      dependentes: 'dependents',
      funcempresa: 'funcEmpresas',

      indeferidasPJ: 'pjpending',
      pendentesPJ: 'pjawaitingpayment',
      confPendentesPJ: 'pjconfirmation',
      emprocessamentoPJ: 'pjprocessing',
      emanalisePJ:  'pjinvalidation',
      canceladasPJ: 'pjcanceled60days',
      implantadasPJ: 'pjdeployed60days',
    };
    let dataObjectState = this.state.dashboardColors;
    let state = this.state;

    if (type === null)
      type = this.state.typeCharts;
    else
      state.typeCharts = type;

    Object.keys(dataObjectState).forEach(function(key) {
      if (type === key) {
        state.dashboardColors[key].color = configBase.corSecundaria;
        state.dashboardColors[key].colorNumber = configBase.corSecundaria;
        state.dashboardColors[key].bg = configBase.corPrincipal;
        state.dashboardColors[key].colorIcon = configBase.corPrincipal;
        state.dashboardColors[key].bgIcon = configBase.corSecundaria;
        state.chartsName = state.dashboardColors[key].defaultStatus;
        state.chartsColor = state.dashboardColors[key].defaultBg;
      }
      else {
        state.dashboardColors[key].color = '#546e7a';
        state.dashboardColors[key].colorNumber = '#263238';
        state.dashboardColors[key].bg = state.dashboardColors[key].defaultColor;
        state.dashboardColors[key].colorIcon = state.dashboardColors[key].defaultColor;
        state.dashboardColors[key].bgIcon = state.dashboardColors[key].defaultBg;
      }
    });

    state.showCharts = 'loading';
    this.setState(state);

    let url = '';

    if (this.state.checkedTypeDashboard === false)//PF
      url = configBase.api + 'Sales/dashboardCharts?access_token='+localStorage.getItem('planos_t');
    else//PJ
      url = configBase.api + 'Companies/dashboardCharts?access_token='+localStorage.getItem('planos_t');

    let dataSubmit = {
      userId: localStorage.getItem('planos_u'),
      days: this.state.daysCharts,
      content: listType[type],
    };

    axios.post(url, dataSubmit)
    .then((response) => {
      let state = this.state;
      state.showCharts = true;
      state.data[0] = {id: type, data: response.data};

      if (state.daysCharts === '60')
        state.tickRotation = -55;// Rotaciona o texto inferior quando for 60 dias
      else
        state.tickRotation = 0;

      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.showCharts = false;
      this.setError('Problema encontrado ao buscar dados do gráfico');
    }.bind(this));
  }

  goShowChartsPJ(type=null) {

  }

  updateDaysSelect(event) {
    let state = this.state;
    state.daysCharts = event.target.value;
    this.setState(state);

    this.goShowCharts(null);
  }

  typeDashboardChange(event) {
    let state = this.state;
    state.checkedTypeDashboard = event.target.checked;
    state.showCharts = false;
    this.setState(state);
  }

  getCountPj() {
    let url = configBase.api + 'Companies/countByUser?access_token='+localStorage.getItem('planos_t');
    let dataSend = {
      user: localStorage.getItem('planos_u')
    };

    axios.post(url, dataSend)
    .then((response) => {
      let state = this.state;
      state.countPJawaitingConfirmation = response.data.countPJawaitingConfirmation;
      state.countPJawaitingPayment = response.data.countPJawaitingPayment;
      state.countPJprocessing = response.data.countPJprocessing;
      state.countPJinValidation = response.data.countPJinValidation;
      state.countPJafterSales = response.data.countPJafterSales;
      state.countPJpending = response.data.countPJpending;
      state.countPJdeployed60Days = response.data.countPJdeployed60Days;
      state.countPJcanceled60Days = response.data.countPJcanceled60Days;
      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar quantidade de propostas PJ');
    }.bind(this));
  }

  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }


  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="dashboard">
          <div id="dashboardTitle">
            <Paper elevation={0} className="paper">
              <Grid container spacing={0}>
                <Grid item xs={12} sm={6} md={6} lg={4}>
                  <Typography variant="button" gutterBottom style={{marginLeft: 6, display: 'block', marginTop: 9}}>
                    DASHBOARD {this.state.checkedTypeDashboard === false ? ('PESSOA FÍSICA'): ('PESSOA JURÍDICA')}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2} md={2} lg={4}></Grid>
                <Grid item xs={12} sm={4} md={4} lg={4}>
                  <Typography component="div" className="checkPfPj">
                    <Grid component="label" container alignItems="center" spacing={1}>
                      <Grid style={{fontSize: 10, lineHeight: '11px'}} item>Pessoa <br/> Física</Grid>
                      <Grid item style={{padding: '4px 0px'}}>
                        <Switch checked={this.state.checkedTypeDashboard} onChange={this.typeDashboardChange.bind(this)} />
                      </Grid>
                      <Grid style={{fontSize: 10, lineHeight: '11px'}} item>Pessoa <br/> Jurídica</Grid>
                    </Grid>
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </div>

          {/* PF */
            this.state.checkedTypeDashboard === false ? (
          <div id="dashboardContent" style={{padding: '15px 20px'}}>
            <Grid container spacing={2}>
              {
                this.state.showClientConfirmation === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.novas.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.novas.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'novas')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.novas.color}}
                          >
                            {configBase.statusNova}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.novas.colorNumber}}
                          >
                            {this.state.countClientConfirmation}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'novaspf')}
                      >
                        <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.novas.bgIcon,
                            color: this.state.dashboardColors.novas.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <AttachMoneyIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {
                this.state.showPending === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.indeferidas.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.indeferidas.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'indeferidas')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.indeferidas.color}}
                          >
                            {configBase.statusIndeferida}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.indeferidas.colorNumber}}
                          >
                            {this.state.countPending}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'indeferidaspf')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.indeferidas.bgIcon,
                            color: this.state.dashboardColors.indeferidas.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <PriorityHighIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {
                this.state.showAwaitingSolution === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.pendentes.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.pendentes.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'pendentes')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.pendentes.color}}
                          >
                            {configBase.statusPendente}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.pendentes.colorNumber}}
                          >
                            {this.state.countAwaitingSolution}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'pendentespf')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.pendentes.bgIcon,
                            color: this.state.dashboardColors.pendentes.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <PlaylistAddCheckIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {
                this.state.showInAverbation === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.emaverbacao.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.emaverbacao.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'emaverbacao')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.emaverbacao.color}}
                          >
                            {configBase.statusEmAverbacao}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.emaverbacao.colorNumber}}
                          >
                            {this.state.countInAverbation}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'emaverbacaopf')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.emaverbacao.bgIcon,
                            color: this.state.dashboardColors.emaverbacao.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <RateReviewIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {
                this.state.showWaitingConfirmation === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.emanalise.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.emanalise.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'emanalise')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.emanalise.color}}
                          >
                            {configBase.statusEmAnalise}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.emanalise.colorNumber}}
                          >
                            {this.state.countWaitingConfirmation}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'emanalisepf')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.emanalise.bgIcon,
                            color: this.state.dashboardColors.emanalise.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <UpdateIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {
                this.state.showCanceledContracts === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.canceladas.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.canceladas.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'canceladas')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.canceladas.color}}
                          >
                            {configBase.statusCanceladas}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.canceladas.colorNumber}}
                          >
                            {this.state.countCanceledContracts}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'canceladaspf')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.canceladas.bgIcon,
                            color: this.state.dashboardColors.canceladas.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <MoneyOffIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {
                this.state.showImplantedContracts === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.implantadas.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.implantadas.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'implantadas')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.implantadas.color}}
                          >
                            {configBase.statusImplementadas}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.implantadas.colorNumber}}
                          >
                            {this.state.countImplantedContracts}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'implantadaspf')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.implantadas.bgIcon,
                            color: this.state.dashboardColors.implantadas.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <DoneAllIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {
                this.state.showFuncEmpresa === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.funcempresa.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.funcempresa.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'funcempresa')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.funcempresa.color}}
                          >
                            {configBase.statusFuncEmpresa}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.funcempresa.colorNumber}}
                          >
                            {this.state.countFuncEmpresa}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'funcempresa')}
                      >
                          <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.funcempresa.bgIcon,
                            color: this.state.dashboardColors.funcempresa.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <WorkIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {
                this.state.showDependents === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.dependentes.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.dependentes.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'dependentes')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.dependentes.color}}
                          >
                            {configBase.statusDependentes}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.dependentes.colorNumber}}
                          >
                            {this.state.countDependents}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'listadependentes')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.dependentes.bgIcon,
                            color: this.state.dashboardColors.dependentes.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <PeopleIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

            </Grid>
          </div>
          ) : (/* PJ */
          <div id="dashboardContent" style={{padding: '15px 20px'}}>
            <Grid container spacing={2}>
              {/* status: AGUARDANDO CONFIRMAÇÃO */
              this.state.showPJawaitingConfirmation === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.confPendentesPJ.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.confPendentesPJ.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'confPendentesPJ')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.confPendentesPJ.color}}
                          >
                            {configBase.statusConfPendentePJ}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.confPendentesPJ.colorNumber}}
                          >
                            {this.state.countPJawaitingConfirmation}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'confpendentespj')}
                      >
                          <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.confPendentesPJ.bgIcon,
                            color: this.state.dashboardColors.confPendentesPJ.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <PlaylistPlayIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {/* status: AGUARDANDO PAGAMENTO */
                this.state.showPJawaitingPayment === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.pendentesPJ.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.pendentesPJ.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'pendentesPJ')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.pendentesPJ.color}}
                          >
                            {configBase.statusPendentePJ}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.pendentesPJ.colorNumber}}
                          >
                            {this.state.countPJawaitingPayment}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'pendentespj')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.pendentesPJ.bgIcon,
                            color: this.state.dashboardColors.pendentesPJ.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <PlaylistAddCheckIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {/* status: EM PROCESSAMENTO */
              this.state.showPJprocessing === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.emprocessamentoPJ.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.emprocessamentoPJ.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'emprocessamentoPJ')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.emprocessamentoPJ.color}}
                          >
                            {configBase.statusEmProcessamentoPJ}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.emprocessamentoPJ.colorNumber}}
                          >
                            {this.state.countPJprocessing}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'emprocessamentopj')}
                      >
                          <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.emprocessamentoPJ.bgIcon,
                            color: this.state.dashboardColors.emprocessamentoPJ.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <LoopIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {/* EM VALIDAÇÃO */
                /* this.state.showPJinValidation === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.emanalisePJ.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.emanalisePJ.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'emanalisePJ')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.emanalisePJ.color}}
                          >
                            {configBase.statusEmAnalisePJ}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.emanalisePJ.colorNumber}}
                          >
                            {this.state.countPJinValidation}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'emanalisepj')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.emanalisePJ.bgIcon,
                            color: this.state.dashboardColors.emanalisePJ.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <UpdateIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('') */
              }

              {/* PENDENTE */
                this.state.showPJpending === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.indeferidasPJ.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.indeferidasPJ.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'indeferidasPJ')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.indeferidasPJ.color}}
                          >
                            {configBase.statusIndeferidaPJ}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.indeferidasPJ.colorNumber}}
                          >
                            {this.state.countPJpending}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'indeferidaspj')}
                      >
                          <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.indeferidasPJ.bgIcon,
                            color: this.state.dashboardColors.indeferidasPJ.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <PriorityHighIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {/* CANCELADO */
                this.state.showPJcanceled60Days === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.canceladasPJ.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.canceladasPJ.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'canceladasPJ')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.canceladasPJ.color}}
                          >
                            {configBase.statusCanceladasPJ}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.canceladasPJ.colorNumber}}
                          >
                            {this.state.countPJcanceled60Days}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'canceladaspj')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.canceladasPJ.bgIcon,
                            color: this.state.dashboardColors.canceladasPJ.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <MoneyOffIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

              {/* ATIVO */
                this.state.showPJdeployed60Days === true ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                  style={{...this.styles.buttonPaper, backgroundColor: this.state.dashboardColors.implantadasPJ.bg}}
                  className="dashboardButtonCLick"
                >
                  <Paper
                    elevation={0}
                    style={{backgroundColor: this.state.dashboardColors.implantadasPJ.bg, cursor: "pointer", width: '100%', minHeight: 'inherit'}}
                  >
                    <Grid container spacing={0} style={{minHeight: 'inherit'}}>
                      <Grid
                        item xs={9} sm={9} md={9} lg={9} className="paper"
                        onClick={this.goShowCharts.bind(this, 'implantadasPJ')}
                      >
                        <div style={{marginTop: 13, textAlign: "left"}}>
                          <Typography
                            variant="overline"display="block" gutterBottom
                            style={{margin: 0, color: this.state.dashboardColors.implantadasPJ.color}}
                          >
                            {configBase.statusImplementadasPJ}
                          </Typography>
                          <Typography
                            variant="h4" display="block" gutterBottom
                            style={{margin: 0, color:  this.state.dashboardColors.implantadasPJ.colorNumber}}
                          >
                            {this.state.countPJdeployed60Days}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item xs={3} sm={3} md={3} lg={3} className="dashboardIcon"
                        onClick={this.goList.bind(this, 'implantadaspj')}
                      >
                         <div
                          style={{
                            ...this.styles.icon,
                            backgroundColor: this.state.dashboardColors.implantadasPJ.bgIcon,
                            color: this.state.dashboardColors.implantadasPJ.colorIcon,
                            marginTop: 7
                          }}
                        >
                          <DoneAllIcon/>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Button>
              </Grid>
                ) : ('')
              }

            </Grid>
          </div>
          )
          }

          {
          this.state.showCharts === true ? (
          <div id="dashboardgraficos" style={{padding: '15px 20px'}}>
            <Paper elevation={0} className="paper">
              <div className="graficostitleL">
                <Typography variant="h6" gutterBottom className="titlePaperForm">
                  {this.state.chartsName}
                </Typography>
              </div>

              <div className="graficostitleR">
                <TextField
                  fullWidth
                  select
                  size="small"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.daysCharts}
                  onChange={this.updateDaysSelect.bind(this)}
                >
                  <option value="7">7 dias</option>
                  <option value="15">15 dias</option>
                  <option value="30">30 dias</option>
                  <option value="60">60 dias</option>
                  <option value="currentMonth">Mês atual</option>
                </TextField>
              </div>

              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={12} lg={12} id="heightgraficos">
                  <ResponsiveLine
                    enableArea={true}
                    data={this.state.data}
                    curve="monotoneX"
                    margin={{ top: 8, right: 15, bottom: 50, left: 30 }}
                    xScale={{ type: 'point' }}
                    yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                      orient: 'bottom',
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: this.state.tickRotation,
                      legendOffset: 36,
                      legendPosition: 'middle'
                    }} 
                    /* axisLeft={{
                      orient: 'left',
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: 'count',
                      legendOffset: -40,
                      legendPosition: 'middle'
                    }} */
                    colors={this.state.chartsColor}
                    //colors={{ scheme: 'category10' }}
                    pointSize={10}
                    pointColor={{ theme: 'background' }}
                    pointBorderWidth={2}
                    pointBorderColor={{ from: 'serieColor' }}
                    pointLabel="y"
                    pointLabelYOffset={-12}
                    useMesh={true}
                    /* legends={[
                      {
                        anchor: 'bottom-right',
                        direction: 'column',
                        justify: false,
                        translateX: 100,
                        translateY: 0,
                        itemsSpacing: 0,
                        itemDirection: 'left-to-right',
                        itemWidth: 80,
                        itemHeight: 20,
                        itemOpacity: 0.75,
                        symbolSize: 12,
                        symbolShape: 'circle',
                        symbolBorderColor: 'rgba(0, 0, 0, .5)',
                        effects: [
                          {
                            on: 'hover',
                            style: {
                              itemBackground: 'rgba(0, 0, 0, .03)',
                              itemOpacity: 1
                            }
                          }
                        ]
                      }
                    ]} */
                  />
                </Grid>
              </Grid>
            </Paper>
          </div>
            ) : (
              this.state.showCharts === 'loading' ? (
          <div id="dashboardgraficos">
            <Paper elevation={0} className="paper">
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={12} lg={12} id="heightgraficosloading">
                  <LinearProgress />
                  <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                    GERANDO GRÁFICO...
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </div>
              ) : ('')
            )
          }

        </div>

        <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
          <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
            {this.state.msgErrorRequest}
          </MuiAlert>
        </Snackbar>
      </MainLayout>
    );

  }

}

Dashboard.propTypes = {
  history: PropTypes.object
};

export default withRouter(Dashboard);